import styled from 'styled-components';

export const StyledWrapper = styled.aside`
  position: relative;
  display: flex;
`;
